let inject = ['$scope', '$uibModalInstance','modalOptions', '$timeout', 'CartService', 'SessionService'];

class CommentCartModalController {
  constructor ($scope,$uibModalInstance,modalOptions, $timeout, CartService, SessionService) {
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.SessionService = SessionService;
    this.CartService = CartService;
    this.$uibModalInstance = $uibModalInstance;
    this.modalOptions = Object.assign({}, modalOptions);
    this.comment = this.modalOptions.comment;
    this.maxlengthComment = 70;
    this.commentSaved = false;
  }

  saveOrderComment () {
    this.addingCommentCart = true;
    this.addedCommentCart = false;
    this.errorAddedCommentCart = false;
    let cartId = this.SessionService.get('cartId') || '';
    let data = {
      'cartId': cartId,
      'comment': this.comment
    };
    if (cartId) {
      this.CartService.updateCommentCart(data).then(response => {

        if (!response.error) {

          this.commentSaved = true;
          this.addingCommentCart = false;
          this.addedCommentCart = true;
          this.messageAddedCommentCart = response.message;
          this.$timeout(() => {
            this.ok();
          }, 3000);
        }
        else {
          this.errorAddedCommentCart = true;
        }
      }).catch(reason => {
        this.addingCommentCart = false;
        this.addedCommentCart = false;
        this.errorAddedCommentCart = true;
      });
    }

  }

  cancel() {
    this.$uibModalInstance.dismiss('cancel');
  }

  ok() {
    this.$uibModalInstance.close(this.comment);
  }
}

CommentCartModalController.$inject = inject;

export default CommentCartModalController;



/** WEBPACK FOOTER **
 ** C:/Users/dares/Documents/SIESA_repositorios/himalaya/www/components/cart/modal-comment-cart/modal-comment-cart.controller.js
 **/